import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Istanbul from './views/Istanbul.vue'
import Pittsburgh from './views/Pittsburgh.vue'
import IstanbulTravel from './views/IstanbulTravel.vue'
import Rsvp from './views/Rsvp.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      component: About,
    },
    {
      path: '/rsvp',
      name: 'rsvp',
      component: Rsvp,
    },
    {
      path: '/pittsburgh',
      name: 'pittsburgh',
      component: Pittsburgh,
    },
    {
      path: '/istanbul',
      name: 'istanbul',
      component: Istanbul,
    },
    {
      path: '/istanbul/guide',
      name: 'istanbulGuide',
      component: IstanbulTravel,
    },
    /*
    {
      path: '/rsvp',
      name: 'rsvp',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/About.vue')
    },
    {
      path: '/registry',
      name: 'registry',
      component: () => import('./views/About.vue')
    },
    {
      path: '/istanbul',
      name: 'istanbul',
      component: () => import('./views/About.vue')
    }
    */
  ]
})
